import React, { Component } from "react";
import { withStore } from "store/storeHandler";

/**
 * getIdTokenWT: 발급된 토큰을 가져오는 함수
 *               만일 만료되었다면 새로 발급해서 가져온다.
 * forceRenewTokenWT: 강제로 토큰을 새로 발급하는 함수
 *
 *  ## 위 두 함수 실행으로 인해 cognitoTokenRefreshError 값이 true가 되면
 *     해당 함수가 어떤 값을 리턴하던 상관없이 자동으로 로그아웃 된다.
 *
 */

const withToken = WrappedComponent => {
  class forceTokenRenewComponent extends Component {
    forceRenewTokenWT = async () => {
      const { hasLoggedIn } = this.props;

      if (!hasLoggedIn) return null;

      const { CognitoAuthActions, AppErrorActions } = this.props;

      try {
        const { isUpdated } = await CognitoAuthActions.forceUpdateToken();
        return isUpdated;
      } catch (error) {
        AppErrorActions.setFatalAppError(error);
        return false;
      }
    };

    async getCognitoIdToken() {
      const { CognitoAuthActions, AppErrorActions } = this.props;
      try {
        const { idToken, hasTokenExpired } =
          await CognitoAuthActions.getFreshIdToken();
        return { idToken, hasTokenExpired };
      } catch (error) {
        AppErrorActions.setFatalAppError(error);
        return { hasTokenExpired: true };
      }
    }

    getIdTokenWT = async () => {
      const { hasLoggedIn } = this.props;

      if (!hasLoggedIn) return { isGuest: true };

      const res = await this.getCognitoIdToken();
      const idToken = res.idToken;
      const hasTokenExpired = res.hasTokenExpired;
      return { idToken, hasTokenExpired };
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          forceRenewTokenWT={this.forceRenewTokenWT}
          getIdTokenWT={this.getIdTokenWT}
        />
      );
    }
  }

  return withStore({
    stateMap: {
      myAccount: ["hasLoggedIn"]
    },
    dispatchMap: ["cognitoAuth", "appError"]
  })(forceTokenRenewComponent);
};

export { withToken };
